import React, { useEffect } from "react";
import {
  OfferAttribute,
  SignUpFormData,
} from "../../../../SignUpFormTypes/signUpFormTypes";
import { Controller, useFormContext } from "react-hook-form";
import { signUpFormValidators } from "../../../../helpers/signUpFormConstants";
import * as RadioGroup from "@radix-ui/react-radio-group";
import OfferBox from "./OfferBox";

type OfferAttributesType = {
  offerOne?: OfferAttribute;
  offerTwo?: OfferAttribute;
  defaultOfferOne?: boolean | null;
};

const OfferInput = ({
  offerOne,
  offerTwo,
  defaultOfferOne,
}: OfferAttributesType) => {
  const { control, setValue } = useFormContext<SignUpFormData>();
  const INPUT_NAME = "offer";

  useEffect(() => {
    if (defaultOfferOne) {
      setValue("promoCode", offerOne?.promoCode || "");
    } else {
      setValue("offer", 2);
      setValue("promoCode", offerTwo?.promoCode || "");
    }
  }, []);

  const handleOfferSelected = (offer: number) => {
    const offerPromoCode =
      offer === 1 ? offerOne?.promoCode : offerTwo?.promoCode;

    setValue("promoCode", offerPromoCode ?? "");
  };

  const handleOnChange =
    (hookChangeFunction: (...event: any[]) => void) =>
    (value: string): void => {
      handleOfferSelected(parseInt(value));
      return hookChangeFunction(parseInt(value));
    };

  return (
    <Controller
      name={INPUT_NAME}
      rules={signUpFormValidators.required}
      control={control}
      render={({ field: { value, onChange, ...field } }) => (
        <RadioGroup.Root
          defaultValue="1"
          onValueChange={handleOnChange(onChange)}
          value={value.toString()}
          id="offerContainer"
          className="flex flex-col items-start gap-4 sm:gap-3 self-stretch"
        >
          <OfferBox
            title={offerOne?.title ?? ""}
            copy={offerOne?.copy ?? ""}
            isSelected={value === 1}
            value="1"
            {...field}
          />
          <OfferBox
            title={offerTwo?.title ?? ""}
            copy={offerTwo?.copy ?? ""}
            isSelected={value === 2}
            value="2"
            {...field}
          />
        </RadioGroup.Root>
      )}
    />
  );
};

export default OfferInput;
